'use client'

import { formatRouteString } from '@/components/untitles';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import React from "react";
import { AdmissionChanceProvider } from "@/context/admission-chance";
import { useTranslations } from 'next-intl';
const PageContainer = dynamic(() => import('@/components/common/page-container'), { ssr: false });
const JourneyTitleCard = dynamic(() => import('@/components/widgets/journey-title-card'), { ssr: false });
const MainSection = dynamic(() => import('@/components/pages/profile/main-section'), { ssr: false });
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
const ProfileForm = dynamic(() => import('@/components/pages/profile/profile-form'), { ssr: false });
const HorizontalLinearStepper = dynamic(() => import('@/components/widgets/horizontal-linear-stepper'), { ssr: false });
const ResultCard = dynamic(() => import('@/components/pages/admission-chance/result-card'), { ssr: false });

export default function RootLayout({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) {

    const t = useTranslations('dana.admission_chance');
    const pathname = usePathname() || "";
    const steps = [t('steps.Contact Info'), t('steps.Basic Profile'), t('steps.Academic'), t('steps.Language'), t('steps.Financial'), t('steps.Other')]
    
    // Map route names to step indices
    const routeToStepIndex: { [key: string]: number } = {
        'contact-info': 0,
        'basic-profile': 1,
        'academic': 2,
        'language': 3,
        'financial': 4,
        'other': 5,
        'result': 6
    };

    return <AdmissionChanceProvider>
        <PageContainer
            className='flex flex-col gap-8 pt-8'
        >
            <JourneyTitleCard
                image={
                    <Image
                        url={'/oc-work-balance.svg'}
                        alt="icon"
                        className="w-[287px]"
                    />
                }
                title={t('banner.title')}
                description={t('banner.description')}
            />
            <MainSection>
                <ProfileForm
                    title={t('steps.' + formatRouteString(pathname))}
                    description={pathname === '/admission-chance/result' ? '' : t('education.description')}
                >
                    <Box
                        paddingTop={4}
                        display={'flex'}
                        justifyContent={'center'}
                    >
                        <HorizontalLinearStepper
                            steps={steps}
                            activeStep={routeToStepIndex[pathname.split('/').pop() || ''] ?? 0}
                        />
                    </Box>
                    <Grid
                        container
                        paddingTop={{ lg: 9, md: 4, sm: 4, xs: 4 }}
                        spacing={3}
                    >
                        {pathname === '/admission-chance/result' ?
                            <>
                                <ResultCard />
                                {children}
                            </>
                            :
                            <>
                                <Grid
                                    container
                                    size={{ lg: 6, sm: 12, md: 12, xs: 12 }}
                                >
                                    {children}
                                </Grid>


                                <Grid
                                    container
                                    size={{ lg: 6, sm: 12, md: 12, xs: 12 }}
                                >
                                    <ResultCard />
                                </Grid>
                            </>
                        }

                    </Grid>
                </ProfileForm>
            </MainSection>
        </PageContainer>
    </AdmissionChanceProvider>
};